module.exports = __webpack_public_path__ + "static/media/thumbnail_utomhus-1.283aa99d.jpg";